// 由 scripts/extract-legacy-texts.ts 產生，不要手改。重跑：bunx tsx scripts/extract-legacy-texts.ts
// 來源：ePortfolio_work/ePortfolio-tsgh/WebContent/{js-my/*.js,**/*.jsp} ＋
//       .tmp/ui/raw-dom/legacy/admin/**/*.html（<script src> 頁面歸屬）
// 方法論見 .tmp/fixloop-fc5/probe/{p5-texts-semantic.ts,p6-page-js-map.ts,p7-texts-tiers.ts}（唯讀凍結）
// 與 docs/LEGACY-TEXTS-REVIEW.md（人工複核紀錄）。

export type TextCategory = 'validation' | 'confirm' | 'success' | 'failure' | 'empty' | 'other';
export type TextTier = 'global' | 'shared' | 'unique';

export interface LegacyTextItem {
  readonly key: string;
  readonly text: string;
  readonly tier: TextTier;
  readonly catAuto: TextCategory;
  readonly catReviewed: TextCategory;
  readonly sourceFile: string;
  readonly pages: readonly string[];
}

/** 101 個可歸頁去重訊息（global 8 + shared 34 + unique 59）。R2：已排除 3 條行內註解死碼（見 stripComments）。 */
export const LEGACY_TEXT_ITEMS: readonly LegacyTextItem[] = [
  {
    "key": "legacy.global.01",
    "text": "下載檔案失敗！",
    "tier": "global",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:124",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.02",
    "text": "是否確定要刪除檔案?",
    "tier": "global",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1102",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.03",
    "text": "未選擇上傳檔案!",
    "tier": "global",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/ePortfolio.js:839",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.04",
    "text": "查無符合的資料",
    "tier": "global",
    "catAuto": "empty",
    "catReviewed": "empty",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:823",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.05",
    "text": "檔案上傳限制：僅支援以下副檔名<br>圖像格式：png、jpeg、jpg、bmp",
    "tier": "global",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1084",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.06",
    "text": "檔案上傳限制：僅支援以下副檔名<br>文書格式：doc、docx、xls、xlsx、ppt、pptx、txt、pdf、odt、ods、odp<br>影音格式：ecm、mp4、mov、avi、wmv、mkv<br>圖像格式：png、jpeg、jpg、bmp",
    "tier": "global",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1071",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.07",
    "text": "沒有符合的結果",
    "tier": "global",
    "catAuto": "empty",
    "catReviewed": "empty",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:801",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.global.08",
    "text": "警告",
    "tier": "global",
    "catAuto": "other",
    "catReviewed": "other",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:603",
    "pages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.shared.01",
    "text": "OOOPS!!! 粉紅底色欄位輸入數字不可超過設定範圍!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:136",
    "pages": [
      "form-co-edit-form-fill-form",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.02",
    "text": "OOOPS!!!<br>粉紅底色欄位為必塡，不可空白並要符合規定字數。",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:118",
    "pages": [
      "form-co-edit-form-fill-form",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.03",
    "text": "下載檔案失敗！",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:286",
    "pages": [
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.04",
    "text": "儲存失敗，請聯絡系統管理員",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:245",
    "pages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.05",
    "text": "只能選擇1張表單!",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:464",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.06",
    "text": "尚未存檔，是否確定要關閉?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/courseModal.js:46",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.07",
    "text": "已完成的表單不需要發送通知，請重新選擇!",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:324",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.08",
    "text": "授課教師僅能為一名",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:1133",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "key": "legacy.shared.09",
    "text": "操作錯誤!您選到已經是停用狀態的表單!",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:250",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.10",
    "text": "操作錯誤!您選到已經是啟用狀態的表單!",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:245",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.11",
    "text": "是否確定要刪除?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/announcementModal.js:40",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.12",
    "text": "是否確定要刪除課程?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:361",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "key": "legacy.shared.13",
    "text": "是否確定要發表單給自己?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/courseFormTab.js:18",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.14",
    "text": "是否確定要發送填寫通知?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:332",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.15",
    "text": "是否確定要移除附件?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:171",
    "pages": [
      "form-co-edit-form-fill-form",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.16",
    "text": "是否確定要變更?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:29",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.17",
    "text": "是否確定要變更新歸屬者？",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:500",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.18",
    "text": "是否確定要變更表單為未完成?",
    "tier": "shared",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:386",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.19",
    "text": "未選擇新填寫者!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:21",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.20",
    "text": "未選擇新歸屬者!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:493",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.21",
    "text": "未選擇是否要變更流程人員!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:497",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.22",
    "text": "未選擇表單!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:134",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.23",
    "text": "查不到資料!",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:284",
    "pages": [
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.24",
    "text": "查詢失敗",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/mainUtils.js:525",
    "pages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.25",
    "text": "查詢失敗，請聯絡系統管理員！",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:337",
    "pages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.26",
    "text": "此計畫尚未安排學員！",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:221",
    "pages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.27",
    "text": "無異動人員！",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:188",
    "pages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.28",
    "text": "行事曆檢視日期不能跨月份!",
    "tier": "shared",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:326",
    "pages": [
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.29",
    "text": "請填寫公告內容",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/announcementModal.js:170",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "vote-excellent-teacher"
    ]
  },
  {
    "key": "legacy.shared.30",
    "text": "超過上課人數.",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:527",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "key": "legacy.shared.31",
    "text": "超過最大字數",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formComment.js:99",
    "pages": [
      "discuss-discuss-board",
      "form-co-edit-form-fill-form",
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.32",
    "text": "錯誤! 已完成的表單才能改為未完成!",
    "tier": "shared",
    "catAuto": "success",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:378",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.33",
    "text": "錯誤! 未選擇表單!",
    "tier": "shared",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:382",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-all-form-list",
      "form-class-form-list",
      "form-form-static-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-tsgh-academic-mom",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "key": "legacy.shared.34",
    "text": "點名代碼長度不足6碼!",
    "tier": "shared",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:246",
    "pages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "key": "legacy.unique.01",
    "text": "下載失敗，請聯絡系統管理員",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:328",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.02",
    "text": "下載失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:38",
    "pages": [
      "instruction-course-department-code"
    ]
  },
  {
    "key": "legacy.unique.03",
    "text": "下載檔案失敗！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/courseFormFinishrate.js:160",
    "pages": [
      "report-ugywm-course-form-finishrate"
    ]
  },
  {
    "key": "legacy.unique.04",
    "text": "不可添加自己!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:147",
    "pages": [
      "form-co-edit-form-form-generator"
    ]
  },
  {
    "key": "legacy.unique.05",
    "text": "主治醫師推薦名單超過2名！",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:116",
    "pages": [
      "vote-dept-manager-recommend"
    ]
  },
  {
    "key": "legacy.unique.06",
    "text": "住院醫師推薦名單超過2名！",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:121",
    "pages": [
      "vote-dept-manager-recommend"
    ]
  },
  {
    "key": "legacy.unique.07",
    "text": "停用失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:596",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.08",
    "text": "僅能上傳xlsx檔案！",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:175",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.09",
    "text": "儲存失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:461",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.10",
    "text": "刪除失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:621",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.11",
    "text": "刪除後無法復原，確定要刪除嗎?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:337",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.12",
    "text": "匯入失敗！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:425",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.13",
    "text": "啟用失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:646",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.14",
    "text": "必須選擇訓練類別!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:22",
    "pages": [
      "form-template-field-type-list"
    ]
  },
  {
    "key": "legacy.unique.15",
    "text": "推薦失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:151",
    "pages": [
      "vote-dept-manager-recommend"
    ]
  },
  {
    "key": "legacy.unique.16",
    "text": "日期時間錯誤!",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:790",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.17",
    "text": "日期時間錯誤!!",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:794",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.18",
    "text": "日期選取不正確!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:222",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.19",
    "text": "是否確定要停用?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:358",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.20",
    "text": "是否確定要啟用?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:364",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.21",
    "text": "有必要欄位未填寫!",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:755",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.22",
    "text": "有指定角色隱藏資料，請輸入去識別期間！",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFieldsConfig.js:58",
    "pages": [
      "form-template-field-type-list"
    ]
  },
  {
    "key": "legacy.unique.23",
    "text": "有簽核流程欄位未填寫!",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:801",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.24",
    "text": "未輸入去識別期間!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:92",
    "pages": [
      "form-template-field-type-list"
    ]
  },
  {
    "key": "legacy.unique.25",
    "text": "未輸入名稱!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:85",
    "pages": [
      "form-template-field-type-list"
    ]
  },
  {
    "key": "legacy.unique.26",
    "text": "本次投票活動沒有貴科部醫師名單，請洽教學室承辦人",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:44",
    "pages": [
      "vote-dept-manager-recommend"
    ]
  },
  {
    "key": "legacy.unique.27",
    "text": "查不到資料!",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/courseFormFinishrate.js:158",
    "pages": [
      "report-ugywm-course-form-finishrate"
    ]
  },
  {
    "key": "legacy.unique.28",
    "text": "查無符合的資料",
    "tier": "unique",
    "catAuto": "empty",
    "catReviewed": "empty",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/indexCommon.js:196",
    "pages": [
      "index"
    ]
  },
  {
    "key": "legacy.unique.29",
    "text": "查詢失敗，請聯絡系統管理員！",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:297",
    "pages": [
      "vote-dept-manager-recommend"
    ]
  },
  {
    "key": "legacy.unique.30",
    "text": "檔案上傳限制：僅支援以下副檔名<br>docx、jpg、pdf、png、doc",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1177",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.31",
    "text": "沒有符合的結果",
    "tier": "unique",
    "catAuto": "empty",
    "catReviewed": "empty",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/indexCommon.js:174",
    "pages": [
      "index"
    ]
  },
  {
    "key": "legacy.unique.32",
    "text": "確定要儲存嗎?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:34",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.33",
    "text": "確定要儲存嗎？",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:48",
    "pages": [
      "instruction-course-department-code"
    ]
  },
  {
    "key": "legacy.unique.34",
    "text": "確定要刪除嗎？",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:68",
    "pages": [
      "instruction-course-department-code"
    ]
  },
  {
    "key": "legacy.unique.35",
    "text": "確定要匯入嗎?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:178",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.36",
    "text": "確認刪除這筆請假單?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1124",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.37",
    "text": "缺訓練科部!",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:760",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.38",
    "text": "表單產生成功",
    "tier": "unique",
    "catAuto": "success",
    "catReviewed": "success",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:217",
    "pages": [
      "form-co-edit-form-form-generator"
    ]
  },
  {
    "key": "legacy.unique.39",
    "text": "說明文字最多100字元！",
    "tier": "unique",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:284",
    "pages": [
      "form-co-edit-form-form-generator"
    ]
  },
  {
    "key": "legacy.unique.40",
    "text": "請先登入系統",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/index.js:21",
    "pages": [
      "index"
    ]
  },
  {
    "key": "legacy.unique.41",
    "text": "請問是否要刪除?",
    "tier": "unique",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/queryPage.js:111",
    "pages": [
      "form-co-edit-form-query-page"
    ]
  },
  {
    "key": "legacy.unique.42",
    "text": "請於備註欄位填寫不同意原因!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1000",
    "pages": [
      "leave-leave-form"
    ]
  },
  {
    "key": "legacy.unique.43",
    "text": "請選擇使用範圍!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:296",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.44",
    "text": "請選擇共用角色!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:299",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.45",
    "text": "請選擇匯入檔案!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:168",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.46",
    "text": "請選擇匯入的投票!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:116",
    "pages": [
      "vote-vote-maintenance"
    ]
  },
  {
    "key": "legacy.unique.47",
    "text": "請選擇匯入的檔案",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:397",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.48",
    "text": "請選擇學年度",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:344",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.49",
    "text": "請選擇投票！",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/totalVoteAnalysisReport.js:25",
    "pages": [
      "vote-total-vote-analysis-report"
    ]
  },
  {
    "key": "legacy.unique.50",
    "text": "請選擇科部!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:288",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.51",
    "text": "請選擇結束時間!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:84",
    "pages": [
      "report-tsgh-gpa-form-report"
    ]
  },
  {
    "key": "legacy.unique.52",
    "text": "請選擇表單!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:66",
    "pages": [
      "report-tsgh-gpa-form-report"
    ]
  },
  {
    "key": "legacy.unique.53",
    "text": "請選擇訓練計畫!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/allStudentScores.js:67",
    "pages": [
      "report-pgywm-all-student-scores"
    ]
  },
  {
    "key": "legacy.unique.54",
    "text": "請選擇訓練類別",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:227",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.55",
    "text": "請選擇部門",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:231",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.56",
    "text": "請選擇醫院",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:348",
    "pages": [
      "report-tsgh-academic-mom"
    ]
  },
  {
    "key": "legacy.unique.57",
    "text": "請選擇類別!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:292",
    "pages": [
      "config-comment"
    ]
  },
  {
    "key": "legacy.unique.58",
    "text": "請選開始時間!",
    "tier": "unique",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:79",
    "pages": [
      "report-tsgh-gpa-form-report"
    ]
  },
  {
    "key": "legacy.unique.59",
    "text": "讀檔失敗!",
    "tier": "unique",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFieldsConfig.js:651",
    "pages": [
      "form-template-field-type-list"
    ]
  }
];

export interface UnmappedTextItem {
  readonly text: string;
  readonly catAuto: TextCategory;
  readonly catReviewed: TextCategory;
  readonly sourceFile: string;
  readonly reason: string;
  /** FC-5 R2（C8）：raw DOM 143 頁全文檢索到這段文字的頁（已排序，可能是空陣列）。 */
  readonly locatedPages: readonly string[];
}

/** 203 條 (b) 取不到，分母不回填。R2：reason 已改成 raw DOM 143 頁全文檢索的真實結果（見 docs/LEGACY-TEXTS-UNMAPPED.md 開頭的分類統計），不再籠統宣稱「靜態無法定位」。 */
export const LEGACY_TEXT_UNMAPPED: readonly UnmappedTextItem[] = [
  {
    "text": "OOOPS!!! 粉紅底色欄位輸入數字不可超過設定範圍!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/coEditForm/fillForm.jsp:477",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/form/coEditForm/fillForm.jsp:477）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "form-co-edit-form-fill-form"
    ]
  },
  {
    "text": "OOOPS!!!<br>粉紅底色欄位為必塡，不可空白並要符合規定字數。",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/coEditForm/fillForm.jsp:458",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/form/coEditForm/fillForm.jsp:458）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "form-co-edit-form-fill-form"
    ]
  },
  {
    "text": "Ooops! 程式發生錯誤！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/errorContent.jsp:5",
    "reason": "位於 .jsp（WEB-INF/views/training/studyRecord/errorContent.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "refId 錯誤!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalStudyTarget.jsp:332",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "下載檔案失敗！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/rollCallModal.jsp:427",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/course/rollCallModal.jsp:427）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-tsgh-study-history-list",
      "form-co-edit-form-fill-form",
      "main-new-main-study-record",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-ugywm-student-dept-satisfy",
      "system-download-log",
      "training-arrange-train",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-transcript-list"
    ]
  },
  {
    "text": "不可同時為評核者及受評者，請檢查!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/setFormFlow.jsp:220",
    "reason": "位於 .jsp（WEB-INF/views/formTemplate/setFormFlow.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "不可添加自己!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/coEditForm/fillForm.jsp:249",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/form/coEditForm/fillForm.jsp:249）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "form-co-edit-form-fill-form"
    ]
  },
  {
    "text": "中醫PGY 沒有 住院醫師資料.",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/tchSatisfactionSurveyReport.jsp:94",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-tch-satisfaction-survey-report",
    "locatedPages": [
      "customer-tsgh-tch-satisfaction-survey-report"
    ]
  },
  {
    "text": "人員已經存在!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:2069",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "來源表單錯誤！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/commonFormTemplate.jsp:154",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-template-common-form-template",
    "locatedPages": [
      "form-template-common-form-template"
    ]
  },
  {
    "text": "修改失敗，請選擇參與部門",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/jobTypeDepartment.jsp:195",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-job-type-department",
    "locatedPages": [
      "config-job-type-department"
    ]
  },
  {
    "text": "停用後將不可再使用此年度，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:319",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-annual",
    "locatedPages": [
      "config-annual"
    ]
  },
  {
    "text": "停用後將不可再使用此組織，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/organization.jsp:233",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-organization",
    "locatedPages": [
      "config-organization"
    ]
  },
  {
    "text": "停用後將不可再使用此訓練類別，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/jobType.jsp:361",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-job-type",
    "locatedPages": [
      "config-job-type"
    ]
  },
  {
    "text": "停用後將不可再使用此課程樣板，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseManage.jsp:570",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-manage",
    "locatedPages": [
      "course-course-manage"
    ]
  },
  {
    "text": "停用後將不可再使用此部門，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/department.jsp:514",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-department",
    "locatedPages": [
      "config-department"
    ]
  },
  {
    "text": "停用後將不可再使用此類別或此所屬類別下所有類別，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseType.jsp:333",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-type",
    "locatedPages": [
      "course-course-type"
    ]
  },
  {
    "text": "分數不可空白",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:863",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "刪除成功!",
    "catAuto": "success",
    "catReviewed": "success",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/questionManage.jsp:568",
    "reason": "位於 .jsp（WEB-INF/views/exam/questionManage.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "刪除成功！資料內容如有引用這個圖檔，需自行移除圖檔連結。",
    "catAuto": "success",
    "catReviewed": "success",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/formImgModal.jsp:48",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 8 頁：announcement-announcement-list, course-clazz-query-list, course-clazz-query-list-class-query, discuss-discuss-board, form-co-edit-form-fill-form, main-new-main-study-record, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "discuss-discuss-board",
      "form-co-edit-form-fill-form",
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "刪除資料後無法復原，是否確定要刪除?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/planInst/planInstModalPlanInst.jsp:881",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-plan-inst-plan-inst-list",
    "locatedPages": [
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "匯入失敗!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:294",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 7 頁：config-annual, config-department, config-device, config-job-title, config-location, config-organization, form-template-form-template",
    "locatedPages": [
      "config-annual",
      "config-department",
      "config-device",
      "config-job-title",
      "config-location",
      "config-organization",
      "form-template-form-template"
    ]
  },
  {
    "text": "匯出 計畫學員於該計畫中的平均成績、排名、百分比 [限 西醫PGY]!",
    "catAuto": "other",
    "catReviewed": "other",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/tsghStudyHistoryList.jsp:122",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-tsgh-study-history-list",
    "locatedPages": [
      "customer-tsgh-tsgh-study-history-list"
    ]
  },
  {
    "text": "匯出 需選定訓練計畫",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/tsghStudyHistoryList.jsp:126",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-tsgh-study-history-list",
    "locatedPages": [
      "customer-tsgh-tsgh-study-history-list"
    ]
  },
  {
    "text": "及格分數大於總分，請修正。",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:240",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "名單內有重複人員，請確認 !",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/teacherPoolList.jsp:214",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-teacher-pool-list",
    "locatedPages": [
      "instruction-teacher-pool-list"
    ]
  },
  {
    "text": "地點已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/location.jsp:269",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-location",
    "locatedPages": [
      "config-location"
    ]
  },
  {
    "text": "存檔失敗，及格分數大於總分，請修正。",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:426",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "存檔完成!!!",
    "catAuto": "other",
    "catReviewed": "success",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/system/messageConfig.jsp:12",
    "reason": "位於 .jsp（WEB-INF/views/system/messageConfig.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "學生資料錯誤!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/planInst/planInstModalPlanInst.jsp:845",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-plan-inst-plan-inst-list",
    "locatedPages": [
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "學習目標的表單不同，不可同時選擇!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/fillChoiceModal.jsp:53",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "學習紀錄已經產生，請繼續填寫內容!",
    "catAuto": "other",
    "catReviewed": "other",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/fillChoiceModal.jsp:163",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "將刪除此類別或此所屬類別下所有類別，是否確定要刪除?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseType.jsp:299",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-type",
    "locatedPages": [
      "course-course-type"
    ]
  },
  {
    "text": "尚有題目未完成設定，請完成設定後再存檔。",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/personalizationGPATab.jsp:81",
    "reason": "位於 .jsp（WEB-INF/views/instruction/personalizationGPATab.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "年度已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:345",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-annual",
    "locatedPages": [
      "config-annual"
    ]
  },
  {
    "text": "年度已被使用，停用後將不可再使用此年度，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:312",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-annual",
    "locatedPages": [
      "config-annual"
    ]
  },
  {
    "text": "必須指定第一關卡之流程人員!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/toHighRiskForm.jsp:483",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, form-plan-form-batch-send",
    "locatedPages": [
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-plan-form-batch-send"
    ]
  },
  {
    "text": "必須指定評核項目!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/toHighRiskForm.jsp:479",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-to-high-risk-form",
    "locatedPages": [
      "customer-tsgh-to-high-risk-form"
    ]
  },
  {
    "text": "應完成日不可小於今日!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:394",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "成員重覆,無法加入!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/main/addCalendarModal.jsp:284",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-dept-admin-main, main-main, vote-excellent-teacher",
    "locatedPages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "text": "授課教師僅能為一名",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:1700",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 js-my/clazzList.js:1700）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-list",
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "text": "新增失敗，表單重複!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseManage.jsp:518",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-manage",
    "locatedPages": [
      "course-course-manage"
    ]
  },
  {
    "text": "日期選取不正確!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/highRiskDoctorReport.jsp:26",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/customer/tsgh/highRiskDoctorReport.jsp:26）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-service-standard-report",
      "form-class-form-list",
      "form-plan-form-list",
      "report-common-class-form-export",
      "report-common-plan-form-export",
      "report-ugywm-student-dept-satisfy",
      "training-arrange-train"
    ]
  },
  {
    "text": "是否確定要上傳?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/certTemplateCfg.jsp:41",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-cert-template-cfg",
    "locatedPages": [
      "customer-tsgh-cert-template-cfg"
    ]
  },
  {
    "text": "是否確定要修改表單?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/formTemplate.jsp:238",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-template-form-template",
    "locatedPages": [
      "form-template-form-template"
    ]
  },
  {
    "text": "是否確定要停用帳戶?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:238",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "是否確定要刪除?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:2354",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 js-my/clazzList.js:2354）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-type",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-type",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-plan-inst-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "是否確定要刪除基本課程?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalCourseTarget.jsp:174",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "是否確定要刪除案例規範?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModaCaseTarget.jsp:120",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "是否確定要刪除課程?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/clazzQueryList_js.jsp:338",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/course/clazzQueryList_js.jsp:338）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": []
  },
  {
    "text": "是否確定要刪除部門?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_deptpartment.jsp:72",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "是否確定要刪除？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:286",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "是否確定要匯入?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/permissionManage/student.jsp:79",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-plan-inst-list",
    "locatedPages": [
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "是否確定要匯入帳號資料？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:547",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "是否確定要匯入年度資料？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:260",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-annual",
    "locatedPages": [
      "config-annual"
    ]
  },
  {
    "text": "是否確定要匯入組織資料？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/organization.jsp:277",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-organization",
    "locatedPages": [
      "config-organization"
    ]
  },
  {
    "text": "是否確定要匯入課程?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:2553",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "是否確定要匯入頭像？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:120",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "是否確定要啟用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:330",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/config/annual.jsp:330）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "config-annual",
      "config-department",
      "config-device",
      "config-job-title",
      "config-job-type",
      "config-location",
      "config-organization",
      "course-course-manage",
      "course-course-type",
      "discuss-discuss-type",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "leave-leave-type"
    ]
  },
  {
    "text": "是否確定要啟用帳戶?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:277",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "是否確定要發表單給自己?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/clazzQueryFormModal.jsp:131",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/course/clazzQueryFormModal.jsp:131）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "是否確定要移除題目圖檔?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/questionManage.jsp:585",
    "reason": "位於 .jsp（WEB-INF/views/exam/questionManage.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "是否確定要複製為新版本?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/formTemplate.jsp:415",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-template-form-template",
    "locatedPages": [
      "form-template-form-template"
    ]
  },
  {
    "text": "是否確定要變更?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/studyRecordStatus.jsp:200",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/training/studyRecord/studyRecordStatus.jsp:200）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "是否設為預設年度?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/annual.jsp:232",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-annual",
    "locatedPages": [
      "config-annual"
    ]
  },
  {
    "text": "最少需建2筆欄位!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/setFormFields.jsp:266",
    "reason": "位於 .jsp（WEB-INF/views/formTemplate/setFormFields.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "期間 開始時間 必須 早於 結束.",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/tchSatisfactionSurveyReport.jsp:88",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-tch-satisfaction-survey-report",
    "locatedPages": [
      "customer-tsgh-tch-satisfaction-survey-report"
    ]
  },
  {
    "text": "未勾選假日/工作日!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveHoliday.jsp:105",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-holiday",
    "locatedPages": [
      "leave-leave-holiday"
    ]
  },
  {
    "text": "未設定應完成日期!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/toHighRiskForm.jsp:431",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, form-plan-form-batch-send",
    "locatedPages": [
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-plan-form-batch-send"
    ]
  },
  {
    "text": "未設定流程!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveType.jsp:299",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-type",
    "locatedPages": [
      "leave-leave-type"
    ]
  },
  {
    "text": "未輸入基準日!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:496",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "未輸入日期!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/planFormDispatch.jsp:13",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-plan-form-dispatch",
    "locatedPages": [
      "form-plan-form-dispatch"
    ]
  },
  {
    "text": "未輸入訓練期間!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/coreCurriculumReport.jsp:147",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, form-plan-form-batch-send",
    "locatedPages": [
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "form-plan-form-batch-send"
    ]
  },
  {
    "text": "未輸入訓練階段部門!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/caseReport.jsp:113",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：customer-tsgh-case-report, customer-tsgh-course-record-report, customer-tsgh-tsgh-student-course-report",
    "locatedPages": [
      "customer-tsgh-case-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-tsgh-student-course-report"
    ]
  },
  {
    "text": "未選取表單名稱!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/common/classFormExport.jsp:84",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：report-common-class-form-export, report-common-plan-form-export",
    "locatedPages": [
      "report-common-class-form-export",
      "report-common-plan-form-export"
    ]
  },
  {
    "text": "未選取訓練計畫!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/common/planFormExport.jsp:110",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：report-common-plan-form-export",
    "locatedPages": [
      "report-common-plan-form-export"
    ]
  },
  {
    "text": "未選取訓練類別!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/common/planFormExport.jsp:105",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：report-common-plan-form-export",
    "locatedPages": [
      "report-common-plan-form-export"
    ]
  },
  {
    "text": "未選擇<spring:message code=\"department\"/>!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/studyItemMaintain.jsp:295",
    "reason": "位於 .jsp（WEB-INF/views/instruction/studyItemMaintain.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "未選擇主治醫師!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/toHighRiskForm.jsp:367",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form",
    "locatedPages": [
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form"
    ]
  },
  {
    "text": "未選擇人員!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/navbar.jsp:67",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 117 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "未選擇來源!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalTranscriptTarget.jsp:180",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "未選擇學員!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/planFormBatchSend.jsp:219",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-plan-form-batch-send",
    "locatedPages": [
      "form-plan-form-batch-send"
    ]
  },
  {
    "text": "未選擇檔案",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/certTemplateCfg.jsp:14",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 11 頁：config-account-v-2, config-annual, config-department, config-device, config-job-title, config-location, config-organization, course-clazz-list, customer-tsgh-cert-template-cfg, exam-question-bank, training-arrange-train",
    "locatedPages": [
      "config-account-v-2",
      "config-annual",
      "config-department",
      "config-device",
      "config-job-title",
      "config-location",
      "config-organization",
      "course-clazz-list",
      "customer-tsgh-cert-template-cfg",
      "exam-question-bank",
      "training-arrange-train"
    ]
  },
  {
    "text": "未選擇檔案!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:2460",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 9 頁：config-account-v-2, config-annual, config-department, config-device, config-job-title, config-location, config-organization, course-clazz-list, exam-question-bank",
    "locatedPages": [
      "config-account-v-2",
      "config-annual",
      "config-department",
      "config-device",
      "config-job-title",
      "config-location",
      "config-organization",
      "course-clazz-list",
      "exam-question-bank"
    ]
  },
  {
    "text": "未選擇檔案！",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/arrangeTrain.jsp:536",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-arrange-train",
    "locatedPages": [
      "training-arrange-train"
    ]
  },
  {
    "text": "未選擇職稱!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_deptpartment.jsp:108",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "未選擇職類!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/studyItemMaintain.jsp:291",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-study-item-maintain",
    "locatedPages": [
      "instruction-study-item-maintain"
    ]
  },
  {
    "text": "未選擇表單!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:2249",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 js-my/clazzList.js:2249）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "未選擇表單範本!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalFormTarget.jsp:222",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "未選擇訓練計畫",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/tsgh/coreSkillFormReport.jsp:120",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 8 頁：customer-tsgh-case-report, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-tsgh-student-course-report, report-tsgh-core-skill-form-report, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-ugywm-student-dept-satisfy",
    "locatedPages": [
      "customer-tsgh-case-report",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-tsgh-student-course-report",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-ugywm-student-dept-satisfy"
    ]
  },
  {
    "text": "未選擇訓練計畫!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/caseReport.jsp:108",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 4 頁：customer-tsgh-case-report, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-tsgh-student-course-report",
    "locatedPages": [
      "customer-tsgh-case-report",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-tsgh-student-course-report"
    ]
  },
  {
    "text": "未選擇訓練類別!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_deptpartment.jsp:104",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "未選擇部門!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_deptpartment.jsp:100",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：config-account-v-2, instruction-study-item-maintain",
    "locatedPages": [
      "config-account-v-2",
      "instruction-study-item-maintain"
    ]
  },
  {
    "text": "未選擇醫院!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:543",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "查不到資料!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/rollCallModal.jsp:425",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/course/rollCallModal.jsp:425）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-tsgh-study-history-list",
      "form-co-edit-form-fill-form",
      "main-new-main-study-record",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-ugywm-student-dept-satisfy",
      "system-download-log",
      "training-arrange-train",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "核心技能低標數值須為正整數",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/tsgh/coreSkillStatistic.jsp:114",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：report-tsgh-core-skill-statistic",
    "locatedPages": [
      "report-tsgh-core-skill-statistic"
    ]
  },
  {
    "text": "核心技能高標數值須為正整數",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/tsgh/coreSkillStatistic.jsp:118",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：report-tsgh-core-skill-statistic",
    "locatedPages": [
      "report-tsgh-core-skill-statistic"
    ]
  },
  {
    "text": "案例數不得小於1",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModaCaseTarget.jsp:102",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "檔案上傳限制：僅支援以下副檔名<br>文書類：doc、docx",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/certTemplateCfg.jsp:86",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：customer-tsgh-cert-template-cfg",
    "locatedPages": [
      "customer-tsgh-cert-template-cfg"
    ]
  },
  {
    "text": "欄位未填，請檢查!<br>",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveType.jsp:256",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-type",
    "locatedPages": [
      "leave-leave-type"
    ]
  },
  {
    "text": "欄位檢核錯誤!!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:435",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "此學員並無五年級計畫！",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/dentisit/teacherMain.js:127",
    "reason": "位於 js-my 檔（js-my/main/dentisit/teacherMain.js），admin raw DOM 143 頁沒有任何一頁以 <script src> 引用它，且全文檢索也查無這段文字，無法歸頁",
    "locatedPages": []
  },
  {
    "text": "此教師已為協同教師",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:1705",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "此教師已為授課教師",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:1714",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "此類別已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseType.jsp:381",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-type",
    "locatedPages": [
      "course-course-type"
    ]
  },
  {
    "text": "沒有 計畫表單查詢功能 權限.",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/arrangeTrain.jsp:588",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-arrange-train, training-plan-inst-plan-inst-list",
    "locatedPages": [
      "training-arrange-train",
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "沒有勾選停用帳戶!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:235",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "沒有勾選啟用帳戶!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2.jsp:274",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "沒有勾選資料!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:408",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "沒有右鍵功能!",
    "catAuto": "other",
    "catReviewed": "other",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetList_js.jsp:354",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "沒有選到欄位資料!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/setFormFields.jsp:155",
    "reason": "位於 .jsp（WEB-INF/views/formTemplate/setFormFields.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "沒有選擇任何檔案!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetTabFiles.jsp:81",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "沒有選擇任何項目!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalStudyTarget.jsp:377",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "沒有選擇學習項目!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/fillChoiceModal.jsp:141",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "沒有選擇資料!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/fillChoiceModal.jsp:48",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "測驗時間已結束!無法繼續作答!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/testingManage.jsp:300",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-testing-manage",
    "locatedPages": [
      "exam-testing-manage"
    ]
  },
  {
    "text": "無五年級計畫！",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/dentisit/studentMain.js:165",
    "reason": "位於 js-my 檔（js-my/main/dentisit/studentMain.js），admin raw DOM 143 頁沒有任何一頁以 <script src> 引用它，且全文檢索也查無這段文字，無法歸頁",
    "locatedPages": []
  },
  {
    "text": "無資料!",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/report/tsgh/planFormStatic2.jsp:106",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 4 頁：report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, training-transcript-list",
    "locatedPages": [
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "training-transcript-list"
    ]
  },
  {
    "text": "目前總分低於及格分數，是否由系統自動調整及格分數?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:644",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "目的職類錯誤！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/commonFormTemplate.jsp:150",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-template-common-form-template",
    "locatedPages": [
      "form-template-common-form-template"
    ]
  },
  {
    "text": "目的醫院錯誤！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/formTemplate/commonFormTemplate.jsp:146",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-template-common-form-template",
    "locatedPages": [
      "form-template-common-form-template"
    ]
  },
  {
    "text": "確定要刪除該人員嗎？",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/coEditForm/fillForm.jsp:218",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-co-edit-form-fill-form",
    "locatedPages": [
      "form-co-edit-form-fill-form"
    ]
  },
  {
    "text": "確定要送出投票嗎?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/excellentTeacher.js:198",
    "reason": "位於 js-my 檔（js-my/vote/excellentTeacher.js），admin raw DOM 143 頁沒有任何一頁以 <script src> 引用它，且全文檢索也查無這段文字，無法歸頁",
    "locatedPages": []
  },
  {
    "text": "禁用語不可為空值!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/forbidWord.jsp:82",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-forbid-word",
    "locatedPages": [
      "config-forbid-word"
    ]
  },
  {
    "text": "第1年日期不正確!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveAnnual.jsp:153",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-annual",
    "locatedPages": [
      "leave-leave-annual"
    ]
  },
  {
    "text": "第2年日期不正確!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveAnnual.jsp:158",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-annual",
    "locatedPages": [
      "leave-leave-annual"
    ]
  },
  {
    "text": "第3年日期不正確!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveAnnual.jsp:163",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-annual",
    "locatedPages": [
      "leave-leave-annual"
    ]
  },
  {
    "text": "系統權限異常，限制存取!",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/decorator.jsp:209",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 120 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-fill-form, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-preview, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-statistic-report, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "系統發生錯誤(404)，請洽資訊人員！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/decorator.jsp:228",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 117 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "系統發生錯誤(500)，請洽資訊人員！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/decorator.jsp:231",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 117 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "組織已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/organization.jsp:259",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-organization",
    "locatedPages": [
      "config-organization"
    ]
  },
  {
    "text": "組織已被使用，停用後將不可再使用此組織，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/organization.jsp:227",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-organization",
    "locatedPages": [
      "config-organization"
    ]
  },
  {
    "text": "結束時間不得小於開始時間",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/main/addCalendarModal.jsp:207",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-dept-admin-main, main-main, vote-excellent-teacher",
    "locatedPages": [
      "main-dept-admin-main",
      "main-main",
      "vote-excellent-teacher"
    ]
  },
  {
    "text": "網路異常，請確定連網後再操作!",
    "catAuto": "other",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/decorator.jsp:219",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 120 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-fill-form, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-preview, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-statistic-report, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-fill-form",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-preview",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-statistic-report",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "考試時間須大於0",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:430",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "職稱已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/jobTitle.jsp:192",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-job-title",
    "locatedPages": [
      "config-job-title"
    ]
  },
  {
    "text": "臨床教師部門必須選取!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/transcriptList.jsp:198",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-transcript-list",
    "locatedPages": [
      "training-transcript-list"
    ]
  },
  {
    "text": "自動配分需要能整除",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:871",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-exam-manage",
    "locatedPages": [
      "exam-exam-manage"
    ]
  },
  {
    "text": "至少須設定1個正確答案",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/initAllQuestion.jsp:416",
    "reason": "位於 .jsp（WEB-INF/views/exam/initAllQuestion.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "至少須設定2個選項",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/initAllQuestion.jsp:404",
    "reason": "位於 .jsp（WEB-INF/views/exam/initAllQuestion.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "表單應完成日需大於系統時間!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/toHighRiskForm.jsp:435",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, form-plan-form-batch-send",
    "locatedPages": [
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-plan-form-batch-send"
    ]
  },
  {
    "text": "訓練階段名稱必須選取!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/transcriptList.jsp:206",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-transcript-list",
    "locatedPages": [
      "training-transcript-list"
    ]
  },
  {
    "text": "訓練類別已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/jobType.jsp:388",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-job-type",
    "locatedPages": [
      "config-job-type"
    ]
  },
  {
    "text": "訓練類別已被使用，停用後將不可再使用此訓練類別，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/jobType.jsp:355",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-job-type",
    "locatedPages": [
      "config-job-type"
    ]
  },
  {
    "text": "訓練類別未填寫",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:419",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：exam-exam-manage, exam-question-bank",
    "locatedPages": [
      "exam-exam-manage",
      "exam-question-bank"
    ]
  },
  {
    "text": "設備已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/device.jsp:266",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-device",
    "locatedPages": [
      "config-device"
    ]
  },
  {
    "text": "設定失敗!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/navbar.jsp:57",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 117 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "設定成功!",
    "catAuto": "success",
    "catReviewed": "success",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/layout/navbar.jsp:55",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 117 頁：announcement-announcement-list, config-account-v-2, config-annual, config-comment, config-department, config-device, config-forbid-word, config-job-title, config-job-type, config-job-type-department, config-location, config-organization, config-role, course-clazz-list, course-clazz-query-list, course-clazz-query-list-class-query, course-course-manage, course-course-static-list, course-course-type, customer-tsgh-case-report, customer-tsgh-cert-template-cfg, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-high-risk-doctor-report, customer-tsgh-high-risk-report, customer-tsgh-high-risk-setting, customer-tsgh-high-risk-setting-report, customer-tsgh-service-standard-cfg-report, customer-tsgh-service-standard-report, customer-tsgh-service-standard-setting, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form, customer-tsgh-tsgh-student-course-report, customer-tsgh-tsgh-study-history-list, discuss-discuss-board, discuss-discuss-type, exam-dispatch-exam, exam-exam-manage, exam-question-bank, exam-question-bank-type, exam-testing-manage, form-all-form-list, form-class-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-form-generator, form-co-edit-form-query-page, form-form-static-list, form-plan-form-batch-send, form-plan-form-dispatch, form-plan-form-list, form-template-common-form-template, form-template-field-type-list, form-template-form-template, form-template-form-template-list, instruction-course-department-code, instruction-plan-target-plan-target-list, instruction-study-item-maintain, instruction-study-item-type-maintain, instruction-teacher-pool-list, leave-leave-annual, leave-leave-form, leave-leave-holiday, leave-leave-type, main-dept-admin-main, main-main, main-new-main-exam-list, main-new-main-study-record, profile-profile-maintenance, report-common-class-form-export, report-common-clazz-attendance-export, report-common-clazz-detail-export, report-common-plan-form-export, report-pgywm-all-student-scores, report-tsgh-academic-mom, report-tsgh-class-form-static, report-tsgh-class-form-static-to-class-form-7, report-tsgh-core-skill-form-report, report-tsgh-core-skill-report-by-form, report-tsgh-core-skill-report-by-student, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, report-tsgh-login-static, report-tsgh-plan-form-static, report-tsgh-plan-form-static-2, report-tsgh-plan-form-static-2-to-plan-form-10, report-tsgh-plan-form-static-2-to-plan-form-9, report-tsgh-plan-form-static-to-plan-form-5, report-ugywm-course-form-finishrate, report-ugywm-student-dept-satisfy, system-about, system-api-log, system-changelog, system-download-log, system-login-log, system-message-config, system-system-config, training-arrange-train, training-education-training, training-education-training-student, training-permission-manage-student, training-permission-manage-teacher, training-plan-inst-clinical-arrange, training-plan-inst-plan-inst-list, training-study-passport-study-passport-list, training-study-record-study-record-fill, training-study-record-study-record-status, training-study-record-study-record-verify, training-transcript-list, vote-dept-manager-recommend, vote-excellent-teacher, vote-total-vote-analysis-report, vote-total-vote-report, vote-vote-maintenance",
    "locatedPages": [
      "announcement-announcement-list",
      "config-account-v-2",
      "config-annual",
      "config-comment",
      "config-department",
      "config-device",
      "config-forbid-word",
      "config-job-title",
      "config-job-type",
      "config-job-type-department",
      "config-location",
      "config-organization",
      "config-role",
      "course-clazz-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query",
      "course-course-manage",
      "course-course-static-list",
      "course-course-type",
      "customer-tsgh-case-report",
      "customer-tsgh-cert-template-cfg",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-high-risk-doctor-report",
      "customer-tsgh-high-risk-report",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-high-risk-setting-report",
      "customer-tsgh-service-standard-cfg-report",
      "customer-tsgh-service-standard-report",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "customer-tsgh-tsgh-student-course-report",
      "customer-tsgh-tsgh-study-history-list",
      "discuss-discuss-board",
      "discuss-discuss-type",
      "exam-dispatch-exam",
      "exam-exam-manage",
      "exam-question-bank",
      "exam-question-bank-type",
      "exam-testing-manage",
      "form-all-form-list",
      "form-class-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-form-generator",
      "form-co-edit-form-query-page",
      "form-form-static-list",
      "form-plan-form-batch-send",
      "form-plan-form-dispatch",
      "form-plan-form-list",
      "form-template-common-form-template",
      "form-template-field-type-list",
      "form-template-form-template",
      "form-template-form-template-list",
      "instruction-course-department-code",
      "instruction-plan-target-plan-target-list",
      "instruction-study-item-maintain",
      "instruction-study-item-type-maintain",
      "instruction-teacher-pool-list",
      "leave-leave-annual",
      "leave-leave-form",
      "leave-leave-holiday",
      "leave-leave-type",
      "main-dept-admin-main",
      "main-main",
      "main-new-main-exam-list",
      "main-new-main-study-record",
      "profile-profile-maintenance",
      "report-common-class-form-export",
      "report-common-clazz-attendance-export",
      "report-common-clazz-detail-export",
      "report-common-plan-form-export",
      "report-pgywm-all-student-scores",
      "report-tsgh-academic-mom",
      "report-tsgh-class-form-static",
      "report-tsgh-class-form-static-to-class-form-7",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-report-by-form",
      "report-tsgh-core-skill-report-by-student",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "report-tsgh-login-static",
      "report-tsgh-plan-form-static",
      "report-tsgh-plan-form-static-2",
      "report-tsgh-plan-form-static-2-to-plan-form-10",
      "report-tsgh-plan-form-static-2-to-plan-form-9",
      "report-tsgh-plan-form-static-to-plan-form-5",
      "report-ugywm-course-form-finishrate",
      "report-ugywm-student-dept-satisfy",
      "system-about",
      "system-api-log",
      "system-changelog",
      "system-download-log",
      "system-login-log",
      "system-message-config",
      "system-system-config",
      "training-arrange-train",
      "training-education-training",
      "training-education-training-student",
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-clinical-arrange",
      "training-plan-inst-plan-inst-list",
      "training-study-passport-study-passport-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status",
      "training-study-record-study-record-verify",
      "training-transcript-list",
      "vote-dept-manager-recommend",
      "vote-excellent-teacher",
      "vote-total-vote-analysis-report",
      "vote-total-vote-report",
      "vote-vote-maintenance"
    ]
  },
  {
    "text": "課程時間設定錯誤！",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/main/calendarClassModal.jsp:33",
    "reason": "位於 .jsp（WEB-INF/views/main/calendarClassModal.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "課程樣板已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseManage.jsp:596",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-manage",
    "locatedPages": [
      "course-course-manage"
    ]
  },
  {
    "text": "課程樣板已被使用，停用後將不可再使用此課程樣板，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseManage.jsp:563",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-manage",
    "locatedPages": [
      "course-course-manage"
    ]
  },
  {
    "text": "請先勾選要分派的學生!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:372",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "請先新增人員資料並存檔後，再維護證照資料",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_certification.jsp:74",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：config-account-v-2, profile-profile-maintenance",
    "locatedPages": [
      "config-account-v-2",
      "profile-profile-maintenance"
    ]
  },
  {
    "text": "請先新增人員資料並存檔後，再維護部門職稱",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/accountV2/accountV2tab_deptpartment.jsp:93",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-account-v-2",
    "locatedPages": [
      "config-account-v-2"
    ]
  },
  {
    "text": "請先選取要設定的學員",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveAnnual.jsp:137",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-annual",
    "locatedPages": [
      "leave-leave-annual"
    ]
  },
  {
    "text": "請先選擇檔案",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/transcriptList.jsp:361",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-transcript-list",
    "locatedPages": [
      "training-transcript-list"
    ]
  },
  {
    "text": "請勾選欲刪除的題目",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/questionManage.jsp:554",
    "reason": "位於 .jsp（WEB-INF/views/exam/questionManage.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "請填寫公告內容",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/announcement/announcementList.jsp:467",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/announcement/announcementList.jsp:467）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "請填寫日期!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/system/changelog.jsp:99",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：system-changelog",
    "locatedPages": [
      "system-changelog"
    ]
  },
  {
    "text": "請填寫題目數量",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/questionBank.jsp:136",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-question-bank",
    "locatedPages": [
      "exam-question-bank"
    ]
  },
  {
    "text": "請至少輸入第1年的起迄時間",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/leave/leaveAnnual.jsp:148",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：leave-leave-annual",
    "locatedPages": [
      "leave-leave-annual"
    ]
  },
  {
    "text": "請至少選取一筆資料",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:283",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-clazz-list",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "請設定應完成日!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:390",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "請設定測試目標!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:402",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "請設定閱卷負責人!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/dispatchExam.jsp:398",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-dispatch-exam",
    "locatedPages": [
      "exam-dispatch-exam"
    ]
  },
  {
    "text": "請輸入下一流程填寫人員再提交！",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/fillForm.jsp:576",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-new-main-study-record, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "請選擇 <spring:message code=",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/planInst/planInstList_js.jsp:523",
    "reason": "位於 .jsp（WEB-INF/views/training/planInst/planInstList_js.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "請選擇公告單位",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/announcement/announcementList.jsp:458",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：announcement-announcement-list, course-clazz-query-list, course-clazz-query-list-class-query",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "請選擇公告對象",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/announcement/announcementList.jsp:461",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：announcement-announcement-list, course-clazz-query-list, course-clazz-query-list-class-query",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "請選擇公告狀態",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/announcement/announcementList.jsp:464",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：announcement-announcement-list, course-clazz-query-list, course-clazz-query-list-class-query",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "請選擇公告類型",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/announcement/announcementList.jsp:455",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：announcement-announcement-list, course-clazz-query-list, course-clazz-query-list-class-query",
    "locatedPages": [
      "announcement-announcement-list",
      "course-clazz-query-list",
      "course-clazz-query-list-class-query"
    ]
  },
  {
    "text": "請選擇匯入的檔案",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/permissionManage/permissionManage_js.jsp:24",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/training/permissionManage/permissionManage_js.jsp:24）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "training-permission-manage-student",
      "training-permission-manage-teacher",
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "請選擇地點類別",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/location.jsp:184",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-location",
    "locatedPages": [
      "config-location"
    ]
  },
  {
    "text": "請選擇填寫者!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/studyRecordStatus.jsp:165",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "請選擇管轄部門",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/device.jsp:180",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：config-device, config-location",
    "locatedPages": [
      "config-device",
      "config-location"
    ]
  },
  {
    "text": "請選擇組別",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/planInst/planInstList_js.jsp:593",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：course-clazz-list, training-plan-inst-plan-inst-list",
    "locatedPages": [
      "course-clazz-list",
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "請選擇表單範本!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseManage.jsp:502",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-manage",
    "locatedPages": [
      "course-course-manage"
    ]
  },
  {
    "text": "請選擇要變更的紀錄!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/studyRecord/studyRecordStatus.jsp:161",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-study-record-study-record-status",
    "locatedPages": [
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "請選擇計畫訓練",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/planInst/planInstList_js.jsp:588",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：training-plan-inst-plan-inst-list",
    "locatedPages": [
      "training-plan-inst-plan-inst-list"
    ]
  },
  {
    "text": "請選擇訓練計畫",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/clertCerk.jsp:126",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 23 頁：course-clazz-list, customer-tsgh-case-report, customer-tsgh-clert-cerk, customer-tsgh-core-curriculum-report, customer-tsgh-course-record-report, customer-tsgh-tch-satisfaction-survey-report, customer-tsgh-tsgh-student-course-report, form-all-form-list, form-co-edit-form-completion-statistics-page, form-co-edit-form-export-page, form-co-edit-form-query-page, form-plan-form-batch-send, leave-leave-annual, leave-leave-form, report-common-plan-form-export, report-tsgh-core-skill-form-report, report-tsgh-core-skill-statistic, report-tsgh-core-skill-sutdent-report, report-tsgh-gpa-form-report, training-permission-manage-student, training-plan-inst-plan-inst-list, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "course-clazz-list",
      "customer-tsgh-case-report",
      "customer-tsgh-clert-cerk",
      "customer-tsgh-core-curriculum-report",
      "customer-tsgh-course-record-report",
      "customer-tsgh-tch-satisfaction-survey-report",
      "customer-tsgh-tsgh-student-course-report",
      "form-all-form-list",
      "form-co-edit-form-completion-statistics-page",
      "form-co-edit-form-export-page",
      "form-co-edit-form-query-page",
      "form-plan-form-batch-send",
      "leave-leave-annual",
      "leave-leave-form",
      "report-common-plan-form-export",
      "report-tsgh-core-skill-form-report",
      "report-tsgh-core-skill-statistic",
      "report-tsgh-core-skill-sutdent-report",
      "report-tsgh-gpa-form-report",
      "training-permission-manage-student",
      "training-plan-inst-plan-inst-list",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "請選擇設備類別",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/device.jsp:184",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-device",
    "locatedPages": [
      "config-device"
    ]
  },
  {
    "text": "請選擇醫院",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/department.jsp:337",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/config/department.jsp:337）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "config-department",
      "config-device",
      "config-job-title",
      "config-location",
      "course-clazz-list",
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form",
      "form-template-form-template"
    ]
  },
  {
    "text": "請選擇醫院及部門",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/customer/tsgh/highRiskSetting.jsp:123",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 4 頁：customer-tsgh-high-risk-setting, customer-tsgh-service-standard-setting, customer-tsgh-to-high-risk-form, customer-tsgh-to-service-standard-form",
    "locatedPages": [
      "customer-tsgh-high-risk-setting",
      "customer-tsgh-service-standard-setting",
      "customer-tsgh-to-high-risk-form",
      "customer-tsgh-to-service-standard-form"
    ]
  },
  {
    "text": "資料有誤",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/dentisit/studentMain.js:124",
    "reason": "位於 js-my 檔（js-my/main/dentisit/studentMain.js），admin raw DOM 143 頁沒有任何一頁以 <script src> 引用它，且全文檢索也查無這段文字，無法歸頁",
    "locatedPages": []
  },
  {
    "text": "超過三個月，為保持伺服器正常運作，請將日期間隔改為三個月內。<br>例如:2023-01-01~2023-03-01",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/system/loginLog.jsp:78",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：system-login-log",
    "locatedPages": [
      "system-login-log"
    ]
  },
  {
    "text": "超過上課人數.",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/clazzList.js:677",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 js-my/clazzList.js:677）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": [
      "course-clazz-list"
    ]
  },
  {
    "text": "退回流程錯誤!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/coEditForm/fillForm.jsp:499",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：form-co-edit-form-fill-form",
    "locatedPages": [
      "form-co-edit-form-fill-form"
    ]
  },
  {
    "text": "選修需填寫[選修案例數]!",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalStudyTarget.jsp:326",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "選擇訓練期間須先選擇訓練計畫",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/training/permissionManage/permissionManage_js.jsp:64",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：training-permission-manage-student, training-permission-manage-teacher",
    "locatedPages": [
      "training-permission-manage-student",
      "training-permission-manage-teacher"
    ]
  },
  {
    "text": "選項內容為必填欄位",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/initAllQuestion.jsp:408",
    "reason": "位於 .jsp（WEB-INF/views/exam/initAllQuestion.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "選項內容重覆",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/initAllQuestion.jsp:412",
    "reason": "位於 .jsp（WEB-INF/views/exam/initAllQuestion.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "部門已被使用，不能刪除，請改成停用",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/department.jsp:540",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-department",
    "locatedPages": [
      "config-department"
    ]
  },
  {
    "text": "部門已被使用，停用後將不可再使用此部門，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/config/department.jsp:508",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：config-department",
    "locatedPages": [
      "config-department"
    ]
  },
  {
    "text": "部門未填寫",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/examManage.jsp:422",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 2 頁：exam-exam-manage, exam-question-bank",
    "locatedPages": [
      "exam-exam-manage",
      "exam-question-bank"
    ]
  },
  {
    "text": "醫策會規定時數錯誤!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalCourseTarget.jsp:156",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "醫院未填寫",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/questionBank.jsp:316",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：exam-question-bank",
    "locatedPages": [
      "exam-question-bank"
    ]
  },
  {
    "text": "錯誤，下一流程填寫人員不可設為自己!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/fillForm.jsp:581",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-new-main-study-record, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "錯誤，加會不可設為自己!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/fillForm.jsp:510",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-new-main-study-record, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "錯誤，未輸入加會人員!",
    "catAuto": "failure",
    "catReviewed": "failure",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/form/fillForm.jsp:506",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，歸屬多頁）——raw DOM 143 頁全文檢索出現在 3 頁：main-new-main-study-record, training-study-record-study-record-fill, training-study-record-study-record-status",
    "locatedPages": [
      "main-new-main-study-record",
      "training-study-record-study-record-fill",
      "training-study-record-study-record-status"
    ]
  },
  {
    "text": "階段執行科部是否改為與計畫執行科部一致?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/instruction/planTarget/planTargetModalPhaseTarget.jsp:564",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：instruction-plan-target-plan-target-list",
    "locatedPages": [
      "instruction-plan-target-plan-target-list"
    ]
  },
  {
    "text": "題目內容為必填欄位",
    "catAuto": "other",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/exam/initAllQuestion.jsp:375",
    "reason": "位於 .jsp（WEB-INF/views/exam/initAllQuestion.jsp），raw DOM 143 頁全文檢索查無這段文字——可能是這段文字的觸發條件（JSTL EL／權限分支）在本次擷取的 9 個測試帳號下都沒有被觸發到，不是「靜態無法定位」",
    "locatedPages": []
  },
  {
    "text": "類別已被使用，停用後將不可再使用此類別或此所屬類別下所有類別，是否確定要停用?",
    "catAuto": "confirm",
    "catReviewed": "confirm",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/courseType.jsp:326",
    "reason": "可歸頁但不在本批凍結分母 101 內（(e) 待辦，需裁決是否納入下一批分母）——raw DOM 143 頁全文檢索只在這一頁出現：course-course-type",
    "locatedPages": [
      "course-course-type"
    ]
  },
  {
    "text": "點名代碼長度不足6碼!",
    "catAuto": "validation",
    "catReviewed": "validation",
    "sourceFile": "ePortfolio_work/ePortfolio-tsgh/WebContent/WEB-INF/views/course/clazzQueryList_js.jsp:217",
    "reason": "文字與既有 101 條可歸頁項目之一重複（同一段訊息、不同呼叫點，原始位置 WEB-INF/views/course/clazzQueryList_js.jsp:217）——這段訊息本身已經有一個可歸頁的代表項，這一筆只是額外的呼叫點",
    "locatedPages": []
  }
];

/** 第一引數為變數／函式呼叫（動態，靜態抽不到字面值）的呼叫點數，(b) 取不到。 */
export const LEGACY_TEXT_DYNAMIC_CALL_SITES = 814;

/** 軸線 A：280 條去重訊息的分類複核覆蓋率（C5-c 分母）。 */
export const TEXT_REVIEW_COVERAGE = {"total":280,"reviewed":280};

/** pageId → 本頁適用的 texts.items（global 依 js 引用關係展開、非逐頁窮舉）。 */
export const LEGACY_TEXTS_BY_PAGE: Readonly<Record<string, readonly string[]>> = {
  "announcement-announcement-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-account-v-2": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-annual": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-comment": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.08",
    "legacy.unique.11",
    "legacy.unique.12",
    "legacy.unique.19",
    "legacy.unique.20",
    "legacy.unique.35",
    "legacy.unique.43",
    "legacy.unique.44",
    "legacy.unique.45",
    "legacy.unique.50",
    "legacy.unique.57"
  ],
  "config-department": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-device": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-forbid-word": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-job-title": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-job-type": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-job-type-department": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-location": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-organization": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "config-role": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "course-clazz-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.23",
    "legacy.shared.28"
  ],
  "course-clazz-query-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.05",
    "legacy.shared.06",
    "legacy.shared.07",
    "legacy.shared.08",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.11",
    "legacy.shared.12",
    "legacy.shared.13",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.23",
    "legacy.shared.28",
    "legacy.shared.29",
    "legacy.shared.30",
    "legacy.shared.32",
    "legacy.shared.33",
    "legacy.shared.34"
  ],
  "course-clazz-query-list-class-query": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.05",
    "legacy.shared.06",
    "legacy.shared.07",
    "legacy.shared.08",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.11",
    "legacy.shared.12",
    "legacy.shared.13",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.23",
    "legacy.shared.28",
    "legacy.shared.29",
    "legacy.shared.30",
    "legacy.shared.32",
    "legacy.shared.33",
    "legacy.shared.34"
  ],
  "course-course-manage": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "course-course-static-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "course-course-type": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-case-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-cert-template-cfg": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-clert-cerk": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "customer-tsgh-core-curriculum-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-course-record-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-high-risk-doctor-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-high-risk-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-high-risk-setting": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-high-risk-setting-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-service-standard-cfg-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-service-standard-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-service-standard-setting": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-tch-satisfaction-survey-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-to-high-risk-form": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "customer-tsgh-to-service-standard-form": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "customer-tsgh-tsgh-student-course-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "customer-tsgh-tsgh-study-history-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "discuss-discuss-board": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.31"
  ],
  "discuss-discuss-type": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "exam-dispatch-exam": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "exam-exam-manage": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "exam-question-bank": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "exam-question-bank-type": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "exam-testing-manage": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-all-form-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "form-class-form-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "form-co-edit-form-completion-statistics-page": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-co-edit-form-export-page": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-co-edit-form-fill-form": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.01",
    "legacy.shared.02",
    "legacy.shared.15",
    "legacy.shared.31"
  ],
  "form-co-edit-form-form-generator": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.04",
    "legacy.unique.38",
    "legacy.unique.39"
  ],
  "form-co-edit-form-query-page": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.41"
  ],
  "form-form-static-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "form-plan-form-batch-send": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-plan-form-dispatch": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-plan-form-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "form-template-common-form-template": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-template-field-type-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.14",
    "legacy.unique.22",
    "legacy.unique.24",
    "legacy.unique.25",
    "legacy.unique.59"
  ],
  "form-template-form-preview": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-template-form-template": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "form-template-form-template-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "index": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.28",
    "legacy.unique.31",
    "legacy.unique.40"
  ],
  "instruction-course-department-code": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.02",
    "legacy.unique.33",
    "legacy.unique.34"
  ],
  "instruction-plan-target-plan-target-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "instruction-study-item-maintain": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "instruction-study-item-type-maintain": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "instruction-teacher-pool-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "leave-leave-annual": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "leave-leave-form": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.16",
    "legacy.unique.17",
    "legacy.unique.21",
    "legacy.unique.23",
    "legacy.unique.30",
    "legacy.unique.36",
    "legacy.unique.37",
    "legacy.unique.42"
  ],
  "leave-leave-holiday": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "leave-leave-type": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "main-dept-admin-main": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.04",
    "legacy.shared.06",
    "legacy.shared.11",
    "legacy.shared.13",
    "legacy.shared.23",
    "legacy.shared.24",
    "legacy.shared.25",
    "legacy.shared.26",
    "legacy.shared.27",
    "legacy.shared.28",
    "legacy.shared.29"
  ],
  "main-main": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.04",
    "legacy.shared.06",
    "legacy.shared.11",
    "legacy.shared.13",
    "legacy.shared.23",
    "legacy.shared.24",
    "legacy.shared.25",
    "legacy.shared.26",
    "legacy.shared.27",
    "legacy.shared.28",
    "legacy.shared.29"
  ],
  "main-new-main-exam-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.01",
    "legacy.shared.02",
    "legacy.shared.03",
    "legacy.shared.06",
    "legacy.shared.11",
    "legacy.shared.13",
    "legacy.shared.15",
    "legacy.shared.23",
    "legacy.shared.28",
    "legacy.shared.29"
  ],
  "main-new-main-study-record": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.01",
    "legacy.shared.02",
    "legacy.shared.03",
    "legacy.shared.06",
    "legacy.shared.11",
    "legacy.shared.13",
    "legacy.shared.15",
    "legacy.shared.23",
    "legacy.shared.28",
    "legacy.shared.29",
    "legacy.shared.31"
  ],
  "profile-profile-maintenance": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-common-class-form-export": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "report-common-clazz-attendance-export": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-common-clazz-detail-export": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-common-plan-form-export": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "report-pgywm-all-student-scores": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.53"
  ],
  "report-tsgh-academic-mom": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33",
    "legacy.unique.01",
    "legacy.unique.18",
    "legacy.unique.47",
    "legacy.unique.48",
    "legacy.unique.54",
    "legacy.unique.55",
    "legacy.unique.56"
  ],
  "report-tsgh-class-form-static": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-class-form-static-to-class-form-7": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-form-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-report-by-form": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-report-by-student": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-statistic": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-statistic-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-core-skill-sutdent-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-gpa-form-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.51",
    "legacy.unique.52",
    "legacy.unique.58"
  ],
  "report-tsgh-login-static": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-plan-form-static": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-plan-form-static-2": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-plan-form-static-2-to-plan-form-10": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-plan-form-static-2-to-plan-form-9": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-tsgh-plan-form-static-to-plan-form-5": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "report-ugywm-course-form-finishrate": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33",
    "legacy.unique.03",
    "legacy.unique.27"
  ],
  "report-ugywm-student-dept-satisfy": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "system-about": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-api-log": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-changelog": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-download-log": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-login-log": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-message-config": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "system-system-config": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-arrange-train": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-education-training": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-education-training-student": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-permission-manage-student": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-permission-manage-teacher": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-plan-inst-clinical-arrange": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-plan-inst-plan-inst-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-study-passport-study-passport-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-study-record-study-record-fill": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.01",
    "legacy.shared.02",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.15",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.31",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "training-study-record-study-record-status": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.01",
    "legacy.shared.02",
    "legacy.shared.05",
    "legacy.shared.07",
    "legacy.shared.09",
    "legacy.shared.10",
    "legacy.shared.14",
    "legacy.shared.15",
    "legacy.shared.16",
    "legacy.shared.17",
    "legacy.shared.18",
    "legacy.shared.19",
    "legacy.shared.20",
    "legacy.shared.21",
    "legacy.shared.22",
    "legacy.shared.31",
    "legacy.shared.32",
    "legacy.shared.33"
  ],
  "training-study-record-study-record-verify": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "training-transcript-list": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "vote-dept-manager-recommend": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.05",
    "legacy.unique.06",
    "legacy.unique.15",
    "legacy.unique.26",
    "legacy.unique.29"
  ],
  "vote-excellent-teacher": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.shared.03",
    "legacy.shared.04",
    "legacy.shared.06",
    "legacy.shared.11",
    "legacy.shared.13",
    "legacy.shared.23",
    "legacy.shared.24",
    "legacy.shared.25",
    "legacy.shared.26",
    "legacy.shared.27",
    "legacy.shared.28",
    "legacy.shared.29"
  ],
  "vote-total-vote-analysis-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.49"
  ],
  "vote-total-vote-report": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08"
  ],
  "vote-vote-maintenance": [
    "legacy.global.01",
    "legacy.global.02",
    "legacy.global.03",
    "legacy.global.04",
    "legacy.global.05",
    "legacy.global.06",
    "legacy.global.07",
    "legacy.global.08",
    "legacy.unique.07",
    "legacy.unique.09",
    "legacy.unique.10",
    "legacy.unique.13",
    "legacy.unique.32",
    "legacy.unique.46"
  ]
};
